import { render, staticRenderFns } from "./NoServerSite.vue?vue&type=template&id=9778bd90&scoped=true&"
import script from "./NoServerSite.vue?vue&type=script&lang=js&"
export * from "./NoServerSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9778bd90",
  null
  
)

export default component.exports